import api from './api';

const userService = {
  // Get all users
  getAllUsers: async () => {
    const response = await api.get('/api/users');
    return response.data;
  },

  // Get user by ID
  getUserById: async (id) => {
    const response = await api.get(`/api/users/${id}`);
    return response.data;
  },

  // Create new user
  createUser: async (userData) => {
    const response = await api.post('/api/users', userData);
    return response.data;
  },

  // Update user
  updateUser: async (id, userData) => {
    const response = await api.put(`/api/users/${id}`, userData);
    return response.data;
  },

  // Reset password (admin)
  resetPassword: async (id, newPassword) => {
    const response = await api.post(`/api/users/${id}/reset-password`, {
      new_password: newPassword,
    });
    return response.data;
  },

  // Change own password
  changeOwnPassword: async (currentPassword, newPassword) => {
    const response = await api.post('/api/users/me/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  // Deactivate user (soft delete)
  deactivateUser: async (id) => {
    const response = await api.patch(`/api/users/${id}/deactivate`);
    return response.data;
  },

  // Hard delete user
  deleteUser: async (id) => {
    const response = await api.delete(`/api/users/${id}`);
    return response.data;
  },

  // Grant business access
  grantBusinessAccess: async (userId, businessId, role) => {
    const response = await api.post(`/api/users/${userId}/business-access`, {
      business_id: businessId,
      role: role,
    });
    return response.data;
  },

  // Revoke business access
  revokeBusinessAccess: async (userId, businessId) => {
    const response = await api.delete(`/api/users/${userId}/business-access/${businessId}`);
    return response.data;
  },
};

export default userService;